module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic_1.ac2b7f27.ttf";